<template>
    <div class="row">
        <div class="col-xl-5 col-lg-6">
            <user-card :user="user"></user-card>
        </div>
        <div class="col-xl-7 col-lg-6">
            <p-button :class="userOrders ? 'active' : null" type="info" size="sm" @click="setUserOrders">
                Recent Orders
            </p-button>
            <p-button :class="userAddresses ? 'active' : null" type="info" size="sm" @click="setUserAddresses">
                User Addresses
            </p-button>
            <user-orders v-if="userOrders" :userOrders="user.orders"></user-orders>
            <user-addresses v-if="userAddresses" :userAddresses="user.addresses"></user-addresses>
        </div>
    </div>
</template>
<script>
import UserCard from 'Shared/Cards/UserCard'
import { USERS, USER_ADDRESSES } from 'db'
import UserOrders from './UserOrders'
import UserAddresses from './UserAddresses'
export default {
    components: {
        UserCard,
        UserOrders,
        UserAddresses
    },
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            USERS,
            USER_ADDRESSES,
            userOrders: true,
            userAddresses: false
        }
    },
    methods: {
        setUserOrders() {
            this.userOrders = true
            this.userAddresses = false
        },
        setUserAddresses() {
            this.userOrders = false
            this.userAddresses = true
        }
    }
}
</script>
